module.exports = __webpack_public_path__ + "static/img/vip_privilege5.b98c4c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vip/vip_privilege5.png
// module id = rqz/
// module chunks = 0